<template>
    <v-row class="d-flex">
        <v-col class="flex-grow-1 flex-shrink-0">
            <v-text-field-filled
                v-model="searchSync"
                label="Rechercher"
                outlined
                hide-details
                density="compact"
                clearable
                append-inner-icon="$search"
                @click:clear="searchSync = ''"
            />
        </v-col>
        <v-col class="d-flex justify-end align-center flex-grow-0 flex-shrink-1">
            <ScopeActionsAddCompany v-if="!hideCompany" v-model:companies="clientsSync" />
            <ScopeActionsAddActivity v-if="!hideActivity" v-model:activities="activitiesSync" />
            <ScopeActionsAddTaxSystem v-if="!hideTaxSystem" v-model:taxSystems="taxSystemsSync" />
        </v-col>
    </v-row>
</template>

<script lang="ts">
import ScopeActionsAddCompany from "./ScopeActionsAddCompany.vue";
import ScopeActionsAddActivity from "./ScopeActionsAddActivity.vue";
import ScopeActionsAddTaxSystem from "./ScopeActionsAddTaxSystem.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component({
    components: {
        ScopeActionsAddCompany,
        ScopeActionsAddActivity,
        ScopeActionsAddTaxSystem,
    },
})
export class ScopeActions extends Vue {
    @Prop({ type: String }) id!: string;

    @Model({ name: "search" }) searchSync!: string;

    @Model({ name: "clients" }) clientsSync!: any[];

    @Model({ name: "activities" }) activitiesSync!: any[];

    @Model({ name: "taxSystems" }) taxSystemsSync!: string[];

    @Prop({ type: Boolean, default: false }) hideCompany!: boolean;
    @Prop({ type: Boolean, default: false }) hideActivity!: boolean;
    @Prop({ type: Boolean, default: false }) hideTaxSystem!: boolean;
}

export default toNative(ScopeActions);
</script>
